import template from './index.pug'

export default Vue.extend({
  template: template(),
  created() {
    this.$setPageTitle('AI Analytics')
  },
})
